'use client';

import classNames from 'classnames';
import { inter500, inter600 } from '@/config/fonts';

import LayoutColumnSvg from '@/assets/svgs/contact-lists/layout-column.svg';
import SparklesTwoSvg from '@/assets/svgs/contact-lists/sparkles-two.svg';

import SelectColumnForField from '@/containers/ContactLists/FieldMapping/SelectColumnForField';
import { ColumnData } from '@/containers/ContactLists/types';

interface P2PUploadStep2SuggestPhoneProps {
  className?: string;
  phoneMappingError?: string; // Error message related to phone number mapping, could be null or a string
  suggestedPhoneNumberColumn?: ColumnData; // Suggested column for phone numbers, could be null or an object
  selectedPhoneNumberColumn?: ColumnData; // Currently selected column for phone numbers, could be null or an object
  columnsOtherThanSuggestedPhoneNumberColumn?: ColumnData[]; // Array of columns excluding the suggested phone number column, could be null or an array of objects
  setSelectedPhoneNumberColumn: (column: ColumnData) => void; // Function to set the selected phone number column
}

const P2PUploadStep2SuggestPhone = ({
  className,
  phoneMappingError,
  suggestedPhoneNumberColumn,
  selectedPhoneNumberColumn,
  columnsOtherThanSuggestedPhoneNumberColumn,
  setSelectedPhoneNumberColumn,
}: P2PUploadStep2SuggestPhoneProps) => {
  return (
    <div className={classNames('', className)}>
      <div className="pb-4">
        <div className={classNames(inter600.className, 'text-2xl')}>
          Select the Column Which Contains{' '}
          <span className="text-primary">Phone Number</span> of Your Contacts
        </div>
        <div className={classNames('pt-2 text-sm text-gray-600 dark:text-gray-400')}>
          Every Contact uploaded must have a Phone Number. Please select the column which
          has the phone numbers.
        </div>
      </div>

      <>
        <div className="flex flex-col gap-6">
          {!!phoneMappingError && (
            <div className="label -mb-4 px-0" role="alert">
              <span className="text-error text-sm">{phoneMappingError}</span>
            </div>
          )}

          {!!suggestedPhoneNumberColumn && (
            <div className="flex flex-col gap-3">
              <div className="flex h-9 items-center gap-3">
                <SparklesTwoSvg />
                <span
                  className={classNames(
                    inter500.className,
                    'text-gray-default text-sm dark:text-gray-400'
                  )}>
                  Suggested
                </span>
              </div>
              <SelectColumnForField
                columnData={suggestedPhoneNumberColumn}
                onSelect={setSelectedPhoneNumberColumn}
                selected={
                  suggestedPhoneNumberColumn.columnNumber ===
                  selectedPhoneNumberColumn?.columnNumber
                }
              />
            </div>
          )}
          <div className="flex flex-col gap-3">
            {suggestedPhoneNumberColumn &&
              !!columnsOtherThanSuggestedPhoneNumberColumn?.length && (
                <div className="flex h-9 items-center gap-3">
                  <LayoutColumnSvg />
                  <span
                    className={classNames(
                      inter500.className,
                      'text-gray-default text-sm dark:text-gray-400'
                    )}>
                    Other columns
                  </span>
                </div>
              )}
            <div className="flex flex-wrap gap-4">
              {columnsOtherThanSuggestedPhoneNumberColumn?.map((data, idx) => {
                return (
                  <SelectColumnForField
                    key={idx}
                    columnData={data}
                    onSelect={setSelectedPhoneNumberColumn}
                    selected={
                      data.columnNumber === selectedPhoneNumberColumn?.columnNumber
                    }
                  />
                );
              })}
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default P2PUploadStep2SuggestPhone;
